import { useQuery } from '@tanstack/react-query';

import { gatewayApiAgent } from 'common/api/apiAgents';
import { ProductFamiliesV2 } from 'common/api-types/catalog';

const PRODUCT_FAMILIES_QUERY_KEY_ROOT = 'productFamilies';

const fetchProductFamilies = async () => {
  const response = await gatewayApiAgent.get<ProductFamiliesV2>(
    '/catalog/public/v2/product-families',
  );
  return response.data;
};

const selectProductFamilies = (productFamilies: ProductFamiliesV2) => {
  return productFamilies
    .filter(
      (productFamily) => productFamily.status === 'ACTIVE' || productFamily.status === 'DEPRECATED',
    )
    .toSorted(
      (a, b) =>
        Number(a.name.startsWith('Other ')) - Number(b.name.startsWith('Other ')) ||
        a.name.localeCompare(b.name),
    );
};

export const useProductFamiliesQuery = (enabled?: boolean) => {
  return useQuery({
    queryKey: [PRODUCT_FAMILIES_QUERY_KEY_ROOT],
    queryFn: fetchProductFamilies,
    select: selectProductFamilies,
    staleTime: Infinity,
    gcTime: Infinity,
    enabled,
  });
};
